export var WidgetHelperCallBack = {
  data() {
    return {
        broker_data : localStorage.getItem("widgetData")
        ? JSON.parse(localStorage.getItem("widgetData"))
        : {},
    };
  },
  updated(){
  },
  
  methods: {
  },
};
